"use strict";

angular.module("licensure.services").factory("EXSkillCategory", [
    "$http",
    "$q",
    function($http, $q) {
        return {
            get: function() {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/EXSkillCategory", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getcategory: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/EXSkillCategory/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function(skill_category) {
                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/EXSkillCategory/";
                if (!isUndefined(skill_category.id)) {
                    method = "PUT";
                    url += skill_category.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        skill_category: skill_category
                    }
                }).then(function (response) {
                    d.resolve(response.data);
                }).catch(function (response) {
                    // handle error
                });

                return d.promise;
            },

            delete: function(id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/EXSkillCategory/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            }
        };
    }
]);
